















































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarMainStreamStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};

  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraPower'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  /*    async getTime() {
           this.ordesList2 = (await this.getTimeSeleccionado()) || [];
           this.data = this.ordesList2[0];
           this.formFields.powerMode.value = parseInt(this.data['?column?'].LittlePowerEnable);
           const on = parseInt(this.data['?column?'].PowerOnTime) / 3600;
           const off = this.convertirSegundosAHora(parseInt(this.data['?column?'].PowerOffTime));
           this.formFields.delayOff.value = parseInt(this.data['?column?'].switch);
           this.formFields.powerOn.value = moment(on, 'HHmm');
           this.formFields.powerOff.value = moment(off, 'HHmm');
           this.formFields.recDelayTime.value = this.data['?column?'].delay;
           this.formFields.autoReboot.value = parseInt(this.data['?column?'].switch);
           this.formFields.rebootTime.value = this.convertirSegundosAHora(parseInt(this.data['?column?'].RebootTime));
           this.formFields.lowVoltagePowOff.value = parseInt(this.data['?column?'].LowPowerOff);
         }
       
         mounted() {
           this.getTime();
         } */
  convertirSegundosAHora(segundos: number): string {
    console.log('prueba:' + segundos);
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    channel: any;
    channelName: any;
    enable: any;
    resolution: any;
    encodeStandard: any;
    frameRate: any;
    quality: any;
    recordMode: any;
    audio: any;
    alarmQuality: any;
    encodeMode: any;
    audioCodingFormat: any;
    percentageMainStream: any;
  } = {
    channel: {
      label: 'Channel',
      value: '0',
      items: [
        { label: '1', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    channelName: {
      label: 'Channel Name',
      value: 'CH1',
    },
    enable: {
      label: 'Enable',
      check: true,
    },
    resolution: {
      label: 'Resolution',
      value: '0',
      items: [
        { label: 'D1', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    encodeStandard: {
      label: 'Encode Standard',
      value: '0',
      items: [
        { label: 'H264', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    frameRate: {
      label: 'Frame Rate',
      value: '0',
      items: [
        { label: '10', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    quality: {
      label: 'Quality',
      value: '0',
      items: [
        { label: '1(Best)', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    recordMode: {
      label: 'Record Mode',
      value: '0',
      items: [
        { label: 'Power Mode', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    audio: {
      label: 'Audio',
      value: '0',
      items: [
        { label: 'No Audio', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    alarmQuality: {
      label: 'Alarm Quality',
      value: '0',
      items: [
        { label: '1(Best)', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    encodeMode: {
      label: 'Encode Mode',
      value: '0',
      items: [
        { label: 'VBR', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    audioCodingFormat: {
      label: 'Audio Coding Format',
      value: '0',
      items: [
        { label: 'ADPCM', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    percentageMainStream: {
      label: 'Percentage Of Main Stream',
      value: '16.7%',
    },
  };
  selectedChannel() {
    return this.formFields.channel.items.find(
      (item: { id: any }) => item.id === this.formFields.channel.value
    );
  }
  selectedResolution() {
    return this.formFields.resolution.items.find(
      (item: { id: any }) => item.id === this.formFields.resolution.value
    );
  }
  selectedAudioCodingFormat() {
    return this.formFields.audioCodingFormat.items.find(
      (item: { id: any }) => item.id === this.formFields.audioCodingFormat.value
    );
  }
  selectedEncodeStandard() {
    return this.formFields.encodeStandard.items.find(
      (item: { id: any }) => item.id === this.formFields.encodeStandard.value
    );
  }
  selectedFrameRate() {
    return this.formFields.frameRate.items.find(
      (item: { id: any }) => item.id === this.formFields.frameRate.value
    );
  }
  selectedRecordMode() {
    return this.formFields.recordMode.items.find(
      (item: { id: any }) => item.id === this.formFields.recordMode.value
    );
  }
  selectedAudio() {
    return this.formFields.audio.items.find(
      (item: { id: any }) => item.id === this.formFields.audio.value
    );
  }
  selectedAlarmQuality() {
    return this.formFields.alarmQuality.items.find(
      (item: { id: any }) => item.id === this.formFields.alarmQuality.value
    );
  }
  selectedEncodeMode() {
    return this.formFields.encodeMode.items.find(
      (item: { id: any }) => item.id === this.formFields.encodeMode.value
    );
  }
  selectedQuality() {
    return this.formFields.quality.items.find(
      (item: { id: any }) => item.id === this.formFields.quality.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
